import { apiBaseUrl } from "../config/runtimeConfig";

const BaseUrl = apiBaseUrl;
export default BaseUrl;